const defaultMapCenter = {
	lat: 47.1665264,
	lng: 27.58285479999995
};

export default defaultMapCenter;
